export default {   
    all: function() {
        return window.axios.get(`retailerTypes`);
    }
}